import { TranslateResult } from "vue-i18n";

export default class Header {

  text: TranslateResult;
  value: string;
  sortable?: boolean = true;

  constructor(
    text: TranslateResult,
    value: string,
    sortable?: boolean,
  ) {
    this.text = text;
    this.value = value;
    this.sortable = sortable ?? true;
  }
}